<template>
  <div :class="['select', {'select-multiple': options && options.isMultiple, 'select-with-mobile': options && options.mobileView}]" :data-select="id">
    <button class="select-selector" @click="clickOnSelector">
      <div class="select-selector-inner">
        <span class="select-selector-options">
          {{selectLabel}}
        </span>
      </div>
    </button>

    <div class="select-dropdown">
      <input class="select-search" v-if="selectorOptions.length > 7" placeholder="Search" type="text" v-model="search">
      <button
        class="select-dropdown-item select-dropdown-item--all"
        v-if="allValue"
        :class="{ active: allValue.active }"
        @click="clickCheckAllOption(allValue, $event)"
      >
        {{allValue.name}}
      </button>
      <div class="select-dropdown-inputs">
          <button
              class="select-dropdown-item"
              v-for="(option, index) in filteredSelectorOptions"
              :key="index"
              :class="{ active: option.active }"
              @click="clickOnDropDownListElement(option, $event)"
              :data-value="option.value"
              :data-key="filterKey"
          >
              {{option.name}}
          </button>
      </div>
    </div>

    <button v-if="options && options.mobileView" class="select-mobile" @click="selectorWindow = true">
      <span class="select-mobile-name">
        {{options.mobileViewLabel ? 'Click here to add '+options.mobileViewLabel : 'Click here to add options'}}
        <template v-if="selectLabel"><br>({{selectLabel}})</template>
      </span>
      <i class="icon-chevron-b"></i>
    </button>

    <transition name="fade">
      <div class="select-mobile-window" v-if="selectorWindow">
        <div class="select-mobile-window-inner">
          <div class="select-mobile-window-top">
            <button class="select-mobile-window-close" @click="selectorWindow = false"><i class="icon-chevron-b"></i></button>
            {{options.mobileViewLabel ? options.mobileViewLabel : 'Options'}}
          </div>

          <form class="form--oneliner">
            <div class="input-wrapper">
              <i class="icon-search"></i>
              <input type="text" placeholder="Start typing..." v-model="search">
            </div>
            <button>Cancel</button>
          </form>

          <div class="select-mobile-list">
            <button v-for="(option, i) in filteredSelectorOptions" :key="i"
            :class="{ active: option.active }"
            @click="clickOnDropDownListElement(option, $event); selectorWindow = false">{{option.name}}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Selector",
  props: ['filterKey', 'allValue', 'selectorOptions', 'options', 'id'],
  data () {
    return {
      // selectLabel: '',
      value: [],
      search:"",
      selectorWindow: false,
    }
  },
  computed: {
      filteredSelectorOptions() {
          if(this.search) {
              return this.selectorOptions.filter(item => {
                  return item.name.toLowerCase().includes(this.search.toLowerCase())
              })
          }
          return this.selectorOptions;
      },
      selectLabel() {
          if(this.value.length) {
              if (this.value.length > 1) {
                  return this.value[0].name + ' + ' + (this.value.length - 1)
              } else {
                  return this.value[0].name
              }
          }
          let actives = this.selectorOptions.filter(item => {
              return item.active;
          })
          if (!actives.length && this.allValue && this.allValue.active) {
              return this.allValue.name;
          }
          this.$emit('refreshTags')
          if(actives.length === 1) {
              return actives[0].name
          }
          if(actives.length > 1) {
              return `${actives[0].name} + ${actives.length - 1}`
          }
          return '';
      }
  },
  mounted () {
    window.addEventListener('mouseup', this.outsideClicker)
    // Get starting value:
    // "all" value
    if (this.allValue && this.allValue.active) {
      this.value.push(this.allValue)
    // pre-selected values
    } else {
      for(var i=0; i < this.selectorOptions.length; ++i) {
        if (this.selectorOptions[i].active) {
          this.value.push(this.selectorOptions[i])
        }
      }
    }
  },
  watch: {
    value: function(val){
      // Create a string with chosen options
      // Emit change event
      this.$emit('change', val, this.filterKey)
    },
  },
  methods: {
    slideUp (target, duration=400) {
      target.style.transitionProperty = 'height, margin, padding'
      target.style.transitionDuration = duration + 'ms'
      target.style.boxSizing = 'border-box'
      target.style.height = target.offsetHeight + 'px'
      target.offsetHeight
      target.style.overflow = 'hidden'
      target.style.height = 0
      target.style.paddingTop = 0
      target.style.paddingBottom = 0
      target.style.marginTop = 0
      target.style.marginBottom = 0
      window.setTimeout( () => {
        target.style.display = 'none'
        target.style.removeProperty('height')
        target.style.removeProperty('padding-top')
        target.style.removeProperty('padding-bottom')
        target.style.removeProperty('margin-top')
        target.style.removeProperty('margin-bottom')
        target.style.removeProperty('overflow')
        target.style.removeProperty('transition-duration')
        target.style.removeProperty('transition-property')
      }, duration)
    },
    slideDown (target, duration=400) {
      target.style.removeProperty('display')
      let display = window.getComputedStyle(target).display
      if (display === 'none')
        display = 'block'
      target.style.display = display
      let height = target.offsetHeight
      target.style.overflow = 'hidden'
      target.style.height = 0
      target.style.paddingTop = 0
      target.style.paddingBottom = 0
      target.style.marginTop = 0
      target.style.marginBottom = 0
      target.offsetHeight
      target.style.boxSizing = 'border-box'
      target.style.transitionProperty = "height, margin, padding"
      target.style.transitionDuration = duration + 'ms'
      target.style.height = height + 'px'
      target.style.removeProperty('padding-top')
      target.style.removeProperty('padding-bottom')
      target.style.removeProperty('margin-top')
      target.style.removeProperty('margin-bottom')
      window.setTimeout( () => {
        target.style.removeProperty('height')
        target.style.removeProperty('overflow')
        target.style.removeProperty('transition-duration')
        target.style.removeProperty('transition-property')
      }, duration)
    },
    slideToggle (target, duration = 400) {
      if (window.getComputedStyle(target).display === 'none') {
        return this.slideDown(target, duration)
      } else {
        return this.slideUp(target, duration)
      }
    },

    // Click anywhere to close the selector
    outsideClicker (e) {
      var selectContainer = this.$el
      if (selectContainer) {
        var me = e.target,
            myParents = []
        while (me) {
          myParents.unshift(me)
          me = me.parentNode
        }
        if (selectContainer != e.target && ! myParents.includes(selectContainer)){
          this.slideUp(selectContainer.querySelector('.select-dropdown'))
          selectContainer.classList.remove('active')
        }
      }
    },

    // Open the dropdown
    clickOnSelector(e) {
      e.preventDefault()
      this.slideToggle(this.$el.querySelector('.select-dropdown'))
      this.$el.classList.toggle('active')
    },

    // Click an option
    clickOnDropDownListElement(clickedOption, e) {
      e.preventDefault()
      let myParent = this.$el

      // Multiple select
      if (this.options && this.options.isMultiple) {
        if(this.allValue) {
          this.allValue.active = false
        }
        clickedOption.active = !clickedOption.active
        var temp = []
        for(var i=0; i < this.selectorOptions.length; ++i) {
          if (this.selectorOptions[i].active) {
            temp.push(this.selectorOptions[i])
          }
        }
        if (temp.length > 0) {
          this.value = temp
        } else {
          if(this.allValue) {
            this.value = [this.allValue]
            this.allValue.active = true
          } else {
            this.value = []
          }
        }
      // Single select
      } else {
        // for(var j=0; i < this.selectorOptions.length; ++j) {
        //
        //   this.selectorOptions[j].active = false
        // }
        // clickedOption.active = true
        this.value = [clickedOption]
      }
      // Close the dropdown if it's a single select
      if (! this.options || ! this.options.isMultiple) {
        myParent.querySelector('.select-dropdown').style.display = 'none'
        myParent.classList.remove('active')
      }
    },

    // Click "all" option in multiple select
    clickCheckAllOption (clickedOption) {
      let myParent = this.$el
      clickedOption.active = true
      for(var i=0; i < this.selectorOptions.length; ++i) {
        this.selectorOptions[i].active = false
      }
      this.value = [clickedOption]
      myParent.querySelector('.select-dropdown').style.display = 'none'
      myParent.classList.remove('active')
    }
  }
}
</script>
